document.addEventListener('DOMContentLoaded', function() {
  // Initialize Slick Carousel once the DOM is fully loaded
  $('.collection-list .slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    infinite: true,
    swipe: true,  // Enable swipe for all devices
    responsive: [
      {
        breakpoint: 750,
        settings: {
          swipe: true,  // Enable swipe for devices with width <= 750px
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }
    ]
  });
});

